export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Do I need to have played lacrosse to use this?',
    answer:
      'No. It is written specifically for coaches who have never played. Every term is explained the first time it appears and every drill includes the exact words to say.',
  },
  {
    question: 'Which age groups does it cover?',
    answer:
      'U8 through U17, roughly ages 7 to 17. There is one volume per age group plus a sixth volume of small-sided games and season plans that works at every level.',
  },
  {
    question: "Is this men's or women's lacrosse?",
    answer:
      "Women's rules only. No body checking, goggles and mouthguards throughout, the center draw and the 8-meter arc.",
  },
  {
    question: 'What format is it and can I print it?',
    answer: 'Print-ready PDF, A4. You can print it as many times as you like, for your whole club, forever.',
  },
  {
    question: 'When do I get access?',
    answer: 'Immediately. The download link arrives by email the moment your payment is confirmed.',
  },
  {
    question: 'Can I use it for a school PE class as well as a club team?',
    answer:
      'Yes. The session plans work in a school PE block and at club training, and the small-sided games volume includes indoor and small-space options.',
  },
]
